import { apiInstance } from 'utils/request'
import { ENTITY_NAMES, RELATIONSHIPS_NAMES } from 'const/api'
import { FIELD_NAMES } from '../../const/forms'
import parseError from 'helpers/parseServerError'

export const getRuleSlugs = ({ page, search, filters, sorter }) =>
  apiInstance
    .get(`/${RELATIONSHIPS_NAMES.ruleSlugs}`, {
      params: {
        filter: {
          search: search ? encodeURIComponent(search) : null,
          ...filters,
        },
        sort: sorter || FIELD_NAMES.id,
        page: {
          number: page,
          size: 20,
        },
      },
    })
    .catch((error) => {
      parseError(error, 'Cannot get rule slugs')
    })

export const deleteRuleSlug = (id) =>
  apiInstance
    .delete(`/${ENTITY_NAMES.ruleSlugs}/${id}`)
    .then(() => ({ data: 'OK' }))
    .catch((error) => {
      parseError(error, "RuleSlug hasn't been deleted")
    })

export const createRuleSlug = (data) =>
  apiInstance
    .post(`/${ENTITY_NAMES.ruleSlugs}`, {
      data,
    })
    .then(() => ({ data: 'OK' }))
    .catch((error) => {
      parseError(error, "RuleSlug hasn't been created")
    })

export const updateRuleSlug = ({ id, data }) =>
  apiInstance
    .patch(`/${ENTITY_NAMES.ruleSlugs}/${id}`, {
      data,
    })
    .then(() => ({ data: 'OK' }))
    .catch((error) => {
      parseError(error, "RuleSlug hasn't been updated")
    })
